module.exports = __webpack_public_path__ + "static/img/7.eb6ca23.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/20/sp/7.png
// module id = uKn2
// module chunks = 0